<template>
  <div class="full-screen-container" :style="telaCheiaBg">
    <div class="media-column" style="position: relative;">
      <div class="media-background" :style="midiaBgStyle" />
      <p class="title-text">{{ headerText }}</p>
      <div class="media-wrapper">
        <img v-if="midiaType === 'image'" :src="midiaUrl" class="image" :style="mediaStyle" style="position: relative;" />
        <video v-else :src="midiaUrl" class="video" autoplay :style="mediaStyle" style="position: relative;" />
      </div>
    </div>
  </div>
</template>

<script>
const midiaBg = require("../../../assets/tarjas/panela-sportv/midia-horizontal-container.png");
const midiaTelaCheiaBg = require("../../../assets/tarjas/panela-sportv/midia-tela-cheia-bg.png");

export default {
  props: {
    headerText: String,
    midiaType: String,
    midiaUrl: String,
    midiaSize: Object,
  },
  computed: {
    mediaStyle() {
      // Verifica se a mídia tem a mesma altura e largura
      if (this.midiaSize && this.midiaSize.width / this.midiaSize.height < (16/9)) {
        return { 
          height: '100%',
          width: 'auto',
          maxHeight: '664px',
          objectFit: 'contain'
        };
      }
      return {
        width: '100%',
        objectFit: 'contain'
      };
    },
    telaCheiaBg() {
      const size = `width: 100vw; min-height: 100vh`;
      const backgroundStyle = `background-image: url(${midiaTelaCheiaBg}); `;
      return `${backgroundStyle}; ${size}`;
    },
    midiaBgStyle() {
      const backgroundStyle = `background-image: url(${midiaBg}); background-repeat: round; background-size: cover;`;
      return `${backgroundStyle};`;
    }
  },
};
</script>

<style scoped lang="scss">
.full-screen-container {
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
}

.media-column {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  z-index: 2;
}

.media-wrapper{
  display: flex;
  align-items: center;
  justify-content: center;
  max-width: 1144px;
  max-height: 664px;
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.image,
.video {
  max-width: 100%;
  max-height: 100%;
  z-index: 1;
  border: 6px solid #bff65c;
  border-radius: 6px;
  object-position: center;
}

.title-text {
  font-size: 4.5rem;
  line-height: 3.5rem;
  color: white;
  z-index: 2;
  font-family: "Galeana-Condensed-Black", sans-serif;
}

.media-background{
  position: absolute; 
  z-index: 0;
  width: 1300px;
  height: 900px;
}
</style>
